import {FjdHeader} from "@efast/fjd-react-components";
import txt from "./../../content.json";
import logo from "../../resources/logo_niedersachsen.svg";

function Header() {
    return (
        <FjdHeader
            logo={<img alt={txt.header.ifsbLogoAlt} src={logo}/>}
        />
    );
}

export default Header;
